import { Box } from "@mui/material";
import { SxProps } from "@mui/material";

type Props = {
  children: React.ReactNode;
  sx?: SxProps;
};

export const ContentWrapNarrow = ({ sx = [], children }: Props) => {
  // wraps content with max midth
  return (
    <Box
      sx={{
        maxWidth: "600px",
        ml: "auto",
        mr: "auto",
        ...(Array.isArray(sx) ? sx : [sx]),
      }}
    >
      {children}
    </Box>
  );
};
